var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkcirclefill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 92.5300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 4.15039C68.0176 4.15039 85.6934-13.5254 85.6934-35.2539C85.6934-56.9824 68.0176-74.6582 46.2402-74.6582C24.5117-74.6582 6.83594-56.9824 6.83594-35.2539C6.83594-13.5254 24.5117 4.15039 46.2402 4.15039Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9434-16.4551C40.4297-16.4551 39.209-17.041 38.0371-18.6035L28.9551-29.9805C28.2715-30.8105 27.9297-31.7871 27.9297-32.7637C27.9297-34.7656 29.3945-36.377 31.4453-36.377C32.666-36.377 33.6426-35.9863 34.7168-34.5215L41.748-25.1465L57.3242-50.3418C58.1055-51.709 59.2285-52.3926 60.4004-52.3926C62.3535-52.3926 64.1113-51.123 64.1113-49.0234C64.1113-48.0469 63.5742-47.0215 62.9883-46.1426L45.6055-18.6035C44.6777-17.1387 43.4082-16.4551 41.9434-16.4551Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkcirclefill);
export default __webpack_public_path__ + "static/media/checkmark.circle.fill.468048b03afcb6fb354af3e0f7fa1eca.svg";
export { ForwardRef as ReactComponent };